var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 121,
    viewBox: "0 0 198 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1814_9893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.38281 52.7734H28.3506V78.3373H21.4819V58.2989H9.25148V78.3373H2.38281V52.7734ZM31.0474 78.3373L43.5931 52.7734H51.0225L63.5683 78.3373H56.6296L54.2816 73.3714H40.5442L38.1963 78.3373H31.0474ZM47.3779 58.8584L42.9973 68.1607H51.7935L47.3779 58.8584ZM81.9767 70.4338H73.1456V78.3373H66.2769V52.7734H81.9767C87.1633 52.7734 91.9643 54.3122 91.9643 61.726C91.9643 69.1749 87.0581 70.4338 81.9767 70.4338ZM85.2008 61.726C85.2008 59.0333 83.8341 58.4038 82.187 58.4038H73.1456V65.0133H82.187C83.8341 65.0133 85.2008 64.3838 85.2008 61.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.347 43.875V61.9551L129.033 43.875H135.937V69.4389H129.594V51.8484L116.872 69.4389H109.969V43.875H116.347ZM159.8 43.875H166.669V69.4389H159.8V59.4721H147.569V69.4389H140.701V43.875H147.569V53.8418H159.8V43.875ZM178.302 49.4004V69.4389H171.433V43.875H194.142V49.4004H178.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1814_9893)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.121 42.0119C134.109 41.9874 134.097 41.9629 134.085 41.9388C129.903 33.3335 119.523 29.7408 110.899 33.9141C102.276 38.0874 98.6757 48.4462 102.858 57.0516C102.87 57.0757 102.882 57.1002 102.894 57.1247L95.0108 60.9397C94.9989 60.9152 94.987 60.891 94.9751 60.8666C88.6815 47.9168 94.0993 32.3279 107.076 26.0476C120.053 19.7673 135.674 25.1739 141.968 38.1235C141.98 38.1479 141.991 38.1724 142.003 38.1969L134.121 42.0119Z",
    fill: "#B63940"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1814_9893)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5824 65.0185C96.5936 65.0412 96.6048 65.0639 96.616 65.087C100.207 72.4768 96.9829 82.4358 87.8984 86.8324C78.8136 91.229 68.9805 87.5895 65.3892 80.1998C65.3779 80.177 65.3667 80.154 65.3559 80.1309L57.4727 83.9462C57.4839 83.969 57.4951 83.992 57.5059 84.0148C63.426 96.1959 78.7445 100.979 91.7214 94.6988C104.698 88.4183 110.419 73.4528 104.499 61.272C104.488 61.2489 104.477 61.2262 104.466 61.2031L96.5824 65.0185Z",
    fill: "#B63940"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1814_9893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.242 75.1562V77.1875H192.914V83.6094H190.281V75.1562H196.242Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.188 78.4531V80.4766H182.969V78.4531H187.188ZM183.93 75.1562V83.6094H181.297V75.1562H183.93ZM188.875 75.1562V83.6094H186.234V75.1562H188.875Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.953 80.0625L177.281 75.1562H179.914V83.6094H177.281V78.6875L174.953 83.6094H172.312V75.1562H174.953V80.0625Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.703 75.1562V83.6094H166.062V75.1562H168.703ZM171.375 75.1562V77.1719H163.438V75.1562H171.375Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.438 83.7656C158.75 83.7656 158.135 83.6589 157.594 83.4453C157.052 83.2266 156.594 82.9271 156.219 82.5469C155.849 82.1667 155.565 81.7292 155.367 81.2344C155.174 80.7396 155.078 80.2161 155.078 79.6641V79.3672C155.078 78.7474 155.164 78.1745 155.336 77.6484C155.508 77.1172 155.763 76.6536 156.102 76.2578C156.44 75.862 156.865 75.5547 157.375 75.3359C157.885 75.112 158.479 75 159.156 75C159.755 75 160.292 75.0964 160.766 75.2891C161.24 75.4818 161.641 75.7578 161.969 76.1172C162.302 76.4766 162.555 76.9115 162.727 77.4219C162.904 77.9323 162.992 78.5052 162.992 79.1406V80.2109H156.086V78.5625H160.422V78.3594C160.427 78.0781 160.378 77.8385 160.273 77.6406C160.174 77.4427 160.029 77.2917 159.836 77.1875C159.643 77.0833 159.409 77.0312 159.133 77.0312C158.846 77.0312 158.609 77.0938 158.422 77.2188C158.24 77.3438 158.096 77.5156 157.992 77.7344C157.893 77.9479 157.823 78.1953 157.781 78.4766C157.74 78.7578 157.719 79.0547 157.719 79.3672V79.6641C157.719 79.9766 157.76 80.2604 157.844 80.5156C157.932 80.7708 158.057 80.9896 158.219 81.1719C158.385 81.349 158.583 81.487 158.812 81.5859C159.047 81.6849 159.312 81.7344 159.609 81.7344C159.969 81.7344 160.323 81.6667 160.672 81.5312C161.021 81.3958 161.32 81.1719 161.57 80.8594L162.766 82.2812C162.594 82.526 162.349 82.763 162.031 82.9922C161.719 83.2214 161.344 83.4089 160.906 83.5547C160.469 83.6953 159.979 83.7656 159.438 83.7656Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.711 75.1562V77.1875H151.383V83.6094H148.75V75.1562H154.711Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.438 76.7812V86.8594H139.805V75.1562H142.258L142.438 76.7812ZM147.625 79.2812V79.4453C147.625 80.0599 147.555 80.6302 147.414 81.1562C147.273 81.6823 147.065 82.1406 146.789 82.5312C146.513 82.9219 146.169 83.2266 145.758 83.4453C145.352 83.6589 144.88 83.7656 144.344 83.7656C143.839 83.7656 143.404 83.6536 143.039 83.4297C142.674 83.2057 142.37 82.8958 142.125 82.5C141.88 82.1042 141.682 81.651 141.531 81.1406C141.38 80.6302 141.26 80.0911 141.172 79.5234V79.3125C141.26 78.7031 141.38 78.138 141.531 77.6172C141.682 77.0911 141.88 76.6328 142.125 76.2422C142.37 75.8516 142.672 75.5469 143.031 75.3281C143.396 75.1094 143.831 75 144.336 75C144.872 75 145.344 75.1016 145.75 75.3047C146.161 75.5078 146.505 75.7995 146.781 76.1797C147.062 76.5547 147.273 77.0052 147.414 77.5312C147.555 78.0573 147.625 78.6406 147.625 79.2812ZM144.992 79.4453V79.2812C144.992 78.9531 144.969 78.6536 144.922 78.3828C144.875 78.1068 144.799 77.8672 144.695 77.6641C144.596 77.4609 144.464 77.3047 144.297 77.1953C144.13 77.0859 143.924 77.0312 143.68 77.0312C143.398 77.0312 143.161 77.0755 142.969 77.1641C142.781 77.2474 142.63 77.3776 142.516 77.5547C142.406 77.7266 142.328 77.9427 142.281 78.2031C142.24 78.4583 142.221 78.7578 142.227 79.1016V79.7422C142.216 80.138 142.255 80.487 142.344 80.7891C142.432 81.0859 142.586 81.3177 142.805 81.4844C143.023 81.651 143.32 81.7344 143.695 81.7344C143.945 81.7344 144.154 81.6771 144.32 81.5625C144.487 81.4427 144.62 81.2786 144.719 81.0703C144.818 80.8568 144.888 80.612 144.93 80.3359C144.971 80.0599 144.992 79.763 144.992 79.4453Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.672 81.4844V78C135.672 77.7604 135.638 77.5547 135.57 77.3828C135.503 77.2109 135.396 77.0781 135.25 76.9844C135.104 76.8854 134.909 76.8359 134.664 76.8359C134.466 76.8359 134.297 76.8698 134.156 76.9375C134.016 77.0052 133.909 77.1068 133.836 77.2422C133.763 77.3776 133.727 77.5495 133.727 77.7578H131.094C131.094 77.3672 131.18 77.0052 131.352 76.6719C131.529 76.3333 131.779 76.0391 132.102 75.7891C132.43 75.5391 132.82 75.3464 133.273 75.2109C133.732 75.0703 134.242 75 134.805 75C135.477 75 136.076 75.112 136.602 75.3359C137.133 75.5599 137.552 75.8958 137.859 76.3438C138.167 76.7865 138.32 77.3438 138.32 78.0156V81.4766C138.32 82.0286 138.352 82.4479 138.414 82.7344C138.477 83.0156 138.565 83.263 138.68 83.4766V83.6094H136.039C135.914 83.349 135.82 83.0312 135.758 82.6562C135.701 82.276 135.672 81.8854 135.672 81.4844ZM135.992 78.4453L136.008 79.8516H134.844C134.599 79.8516 134.391 79.8854 134.219 79.9531C134.052 80.0208 133.917 80.1146 133.812 80.2344C133.714 80.349 133.641 80.4792 133.594 80.625C133.552 80.7708 133.531 80.9245 133.531 81.0859C133.531 81.2422 133.568 81.3828 133.641 81.5078C133.719 81.6276 133.823 81.7214 133.953 81.7891C134.083 81.8568 134.229 81.8906 134.391 81.8906C134.682 81.8906 134.93 81.8359 135.133 81.7266C135.341 81.612 135.5 81.474 135.609 81.3125C135.719 81.151 135.773 81 135.773 80.8594L136.352 81.9375C136.247 82.1458 136.128 82.3568 135.992 82.5703C135.862 82.7839 135.698 82.9818 135.5 83.1641C135.307 83.3411 135.07 83.487 134.789 83.6016C134.508 83.7109 134.167 83.7656 133.766 83.7656C133.245 83.7656 132.766 83.6589 132.328 83.4453C131.896 83.2318 131.549 82.9349 131.289 82.5547C131.029 82.1693 130.898 81.7266 130.898 81.2266C130.898 80.7891 130.977 80.3984 131.133 80.0547C131.294 79.7109 131.536 79.4193 131.859 79.1797C132.182 78.9401 132.594 78.7578 133.094 78.6328C133.594 78.5078 134.182 78.4453 134.859 78.4453H135.992Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75 75.1562V83.6094H125.109V75.1562H127.75ZM130.422 75.1562V77.1719H122.484V75.1562H130.422Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.641 80.0625L114.969 75.1562H117.602V83.6094H114.969V78.6875L112.641 83.6094H110V75.1562H112.641V80.0625Z",
    fill: "#8586A5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1814_9893",
    x: 84.3516,
    y: 23.4297,
    width: 65.6523,
    height: 53.5078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1814_9893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1814_9893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1814_9893",
    x: 57.4727,
    y: 53.2031,
    width: 65.3613,
    height: 52.2578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1814_9893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1814_9893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1814_9893",
    x: 106,
    y: 75,
    width: 94.2422,
    height: 19.8594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1814_9893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1814_9893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1814_9893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 121,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2861125c8f1ddb9aae43d83aaae3e6dc.svg";
export { ForwardRef as ReactComponent };